import routes from '../routes';
import AuthContainer from '../../Auth/Container/Container';
import OAuthCallback from '../../Auth/OAuthCallback/OAuthCallback';
import { ForbiddenPage } from 'src/share/components/ErrorPage/ForbiddenPage';
import GlobalDashboardView from '../../Dashboard/Global/GlobalDashboard';
import { RoutePathsFn, IRouteModule, RoutesModules } from '../types';
import PartnersDashboard from 'src/modules/Dashboard/Partners/PartnersDashboard';
import ClubList from 'src/modules/Dashboard/Partners/club-list/ClubList';

const moduleRoutes: RoutePathsFn = () => ([
  {
    paths: [routes.LOGIN, `${routes.LOGIN}/:redirectTo`],
    component: AuthContainer,
    policies: [],
    hideNavBar: true
  },
  {
    paths: [routes.AUTH_CALLBACK],
    component: OAuthCallback,
    policies: [],
    hideNavBar: true,
  },
  {
    paths: [routes.FORBIDDEN],
    component: ForbiddenPage,
    policies: []
  },
  {
    paths: [routes.GLOBALDASHBOARD],
    component: GlobalDashboardView,
    policies: [],
    hideNavBar: true
  },
  {
    paths: [routes.FOOTBALL_CARES],
    component: PartnersDashboard,
    policies: [],
    hideNavBar: true
  },
  {
    paths: [routes.FOOTBALL_CARES_CLUBS],
    component: ClubList,
    policies: [],
    hideNavBar: true
  }
]);

export const publicModule = (): IRouteModule => ({
  routes: moduleRoutes(),
  name: RoutesModules.PUBLIC,
});